import './App.css';
import PageView from './page/pageview.js';
function App() {
  return (
    <div className="App">
     <div  className="main-wrap" >
     <PageView />
     </div>
    </div>
  );
}

export default App;
